/* eslint-disable react/no-access-state-in-setstate */
import React, { Component } from "react";
import update from "immutability-helper";
import moment from "moment";
import {
  RegionServiceChristchurch,
  RegionServiceTimaru
} from "../utilities/regions";

import Form from "./Form";
import { constructURL } from "../utilities";
import DATE_FORMATS from "../utilities/constants";

class JourneyPlanner extends Component {
  constructor(props) {
    super(props);

    let RegionService = RegionServiceChristchurch;

    if (window.REGION === "timaru") {
      RegionService = RegionServiceTimaru;
    }

    this.state = {
      goDisabled: true,
      RegionService,
      params: {
        from: "",
        to: "",
        fromLatitude: "",
        fromLongitude: "",
        toLatitude: "",
        toLongitude: "",
        date: moment(new Date()).format(DATE_FORMATS.Date),
        time: moment(new Date()).format(DATE_FORMATS.Time),
        timeType: "dep",
        sortOrder: "duration",
        preferredRoute: "",
        region: RegionService.region
      }
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const from = document.getElementsByName("from")[0];
    const to = document.getElementsByName("to")[0];
    if (typeof e === "object") {
      const name = Object.keys(e)[0];
      const value = Object.values(e)[0];

      this.setState(
        update(this.state, {
          params: { $merge: { [name]: value } }
        })
      );
    }

    if (from.value && to.value) {
      this.setState({
        goDisabled: false
      });
    } else {
      this.setState({
        goDisabled: true
      });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleSubmit(event) {
    event.preventDefault();

    const baseUri = window.JPURL;
    const { params } = this.state;

    const url = constructURL(baseUri, params, "#/journey_plans/create");

    window.location = url;
  }

  render() {
    const { RegionService } = this.state;

    return (
      <div className="emberjs-container rjp">
        <div className="embedded">
          <div className="embed-header">
            <h1>Plan your bus trip</h1>
            <h2>in {RegionService.homepageRegion}</h2>
          </div>
          <Form
            RegionService={RegionService}
            onSubmit={e => this.handleSubmit(e)}
            onChange={e => this.handleChange(e)}
            {...this.state}
          />
        </div>
      </div>
    );
  }
}

export default JourneyPlanner;
